import Semed from "../Semed";

class News {
  async highlights () {
    return Semed.get('/education/highlights/news/resume')
  }
  async resumes () {
    return Semed.get('/education/news/resumes')
  }
}
export default new News()
